import {ManageWisbitActionType, WisbitItem} from '../types';

export const LOAD_WISBITS_REQUEST = 'ManageWisbitPage/LOAD_WISBITS_REQUEST';
export const LOAD_WISBITS_SUCCESS = 'ManageWisbitPage/LOAD_WISBITS_SUCCESS';
export const LOAD_WISBITS_FAILURE = 'ManageWisbitPage/LOAD_WISBITS_FAILURE';

export function loadWisbitsRequest(): ManageWisbitActionType {
  return {
    type: LOAD_WISBITS_REQUEST,
    payload: {},
  };
}

export function loadWisbitsSuccess(data: WisbitItem[]): ManageWisbitActionType {
  return {
    type: LOAD_WISBITS_SUCCESS,
    payload: {
      data,
    },
  };
}

export function loadWisbitsFailure(error: Error): ManageWisbitActionType {
  return {
    type: LOAD_WISBITS_FAILURE,
    payload: {
      error,
    },
  };
}
